import { hMacAjax } from 'grt-tool-lib-front';
import { baseURL } from '@/httpService/API';
// const baseUserURL = `${baseURL}/grt-user-service`;
const baseCenterURL = `${baseURL}/grt-user-center-service`;

// //课程学习人数 business_id template_id
// export const getStudentNum = (data) => {
//     return hMacAjax.get(baseCenterURL + '/open/business/v1/learn-num', data);
// };
// // 收藏接口
// export const addCollect = (data) => {
//     return hMacAjax.post(baseCenterURL + '/user/favorite/add', data);
// };

//获取学员信息 学时学分
export const handlePersonalInfo = () => {
    return hMacAjax.get(baseCenterURL + '/user/student/archives/v1/personal/info');
};

//获取学员信息 学时学分
export const handleArchivesRecordList = (data) => {
    return hMacAjax.get(baseCenterURL + '/user/student/archives/v1/record', {...data});
};

// 申报记录
export const handleDeclarationRecordList = (data) => {
    return hMacAjax.post(baseCenterURL + '/user/student/archives/v1/report/list', data);
};
// 学时学分详情
export const handleDeclarationArchives = (id) => {
    return hMacAjax.get(baseCenterURL + '/user/student/archives/v1/' + id);
};
// 审核原因
export const handleDeclarationReason = (id) => {
    return hMacAjax.get(baseCenterURL + '/user/student/archives/v1/report/' + id + '/audit');
};

// 申报记录详情
export const handleDeclarationDetail = (id) => {
    return hMacAjax.get(baseCenterURL + '/user/student/archives/v1/report/' + id);
};

// 表单
export const handleDeclarationFormList = (category_id) => {
    return hMacAjax.get(baseCenterURL + '/user/student/archives/v1/categories/' + category_id + '/config');
};

// 分类
export const handleDeclarationCategoryList = () => {
    return hMacAjax.get(baseCenterURL + '/user/student/archives/v1/categories/list');
};

// 分类
export const handleDeclarationCategoryAllList = () => {
    return hMacAjax.get(baseCenterURL + '/user/student/archives/v1/categories/all/list');
};
// 添加记录
export const handleAddDeclarationInfo = (completeMap) => {
    let data = {
        ...completeMap
    };
    return hMacAjax.post(baseCenterURL + '/user/student/archives/v1/report', data, true);
};

export const handleEditDeclarationInfo = (completeMap) => {
    let data = {
        ...completeMap
    };
    return hMacAjax.put(baseCenterURL + '/user/student/archives/v1/report', data);
};

// 用户基础信息
export const handleUserInfo = () => {
    return hMacAjax.get(baseCenterURL + '/user/student/archives/v1/user/info');
};

// 申报查询培训计划
export const handleTrainPlan = () => {
    return hMacAjax.get(baseCenterURL + '/user/tp/v1/listApplyTrainPlan');
};

// 获取培训计划配置
export const handleTrainPlanConfig = (data) => {
    return hMacAjax.get(baseCenterURL + '/user/tp/v1/getTrainPlanConfig', data);
};

// 申报查询培训类型
export const handleTrainType = (data) => {
    return hMacAjax.get(baseCenterURL + '/user/tp/v1/listApplyTrainType', data);
    // return hMacAjax.get(baseCenterURL + '/user/tp/v1/listTrainType', data);
};